// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 678 ? "component---src-pages-index-js" : chunkId) + "-" + {"231":"35b77288e318fc98a0c7","610":"dceee932861a9525e0cc","678":"c4353690fd8f0014448d","898":"129a47bc0a3e41e19727"}[chunkId] + ".js";
};